import { Users } from 'lucide-react';
import ContactLists from '../ContactList/ContactLists';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../ui/tabs';
import Contacts from './Contacts';

const ContactTabs = () => {
  return (
    <div>
      <div className="flex items-center justify-between gap-2 mb-8">
        <div className="flex items-center gap-2 mb-4 ">
          <Users />
          <div className="text-lg font-bold">Contacts</div>
        </div>
      </div>
      <Tabs defaultValue="contacts" className="w-full -mt-8">
        <TabsList>
          <TabsTrigger value="contacts">Contacts</TabsTrigger>
          <TabsTrigger value="lists">Lists</TabsTrigger>
        </TabsList>

        <TabsContent value="contacts">
          <Contacts />
        </TabsContent>
        <TabsContent value="lists">
          <ContactLists />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default ContactTabs;
